import { render, staticRenderFns } from "./AdjuntarComprobante.vue?vue&type=template&id=52160b34&"
import script from "./AdjuntarComprobante.vue?vue&type=script&lang=js&"
export * from "./AdjuntarComprobante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports